const createTimeline = (el: HTMLElement) => {
	const years = el.querySelectorAll<HTMLElement>('[data-timeline-year]');
	const contentList = el.querySelectorAll<HTMLElement>(
		'[data-timeline-content]',
	);

	const reset = (year: HTMLElement) => {
		contentList.forEach((content) => {
			content.style.display = 'none';
		});

		years.forEach((y) => {
			y.classList.remove('timeline__timeline--active');
		});

		year.classList.add('timeline__timeline--active');
		const contentSelector = year.getAttribute('data-timeline-year');

		if (contentSelector) {
			const content = el.querySelector<HTMLElement>(contentSelector);
			if (content) {
				content.style.removeProperty('display');
			}
		}
	};

	years.forEach((year, index) => {
		if (index === 0) {
			reset(year);
		}

		year.addEventListener('click', () => {
			reset(year);
		});
	});
};
const timelines = document
	.querySelectorAll<HTMLElement>('[data-timeline]')
	.forEach(createTimeline);
